import { type ExcalidrawFontFaceDescriptor } from "../Fonts";

import QomraMedium from "./Qomra-Medium-67fba670.woff2";

/**
 * KHIYARSA PATCH (see PATCHES.khiyarsa.md): PRIMARY Arabic font.
 *
 * "itf Qomra Arabic" Medium (weight class 500) — the authoritative source is
 * the checked-in OTF `itfQomraArabic-Medium-0ekcf9.otf` in this directory;
 * the woff2 is DERIVED from it by `generate.mjs` (content-hashed filename
 * because nginx caches /fonts/ for 30 days). Never swap the OTF for another
 * Qomra cut.
 *
 * The unicode-range below is the font's EXACT Arabic-script cmap coverage
 * (computed from the OTF, 187 codepoints): Arabic punctuation, the full
 * standard alphabet + harakat, Arabic-Indic digits, a few extended letters
 * (پ چ ڤ ں), ornate parentheses, and its presentation forms. Two deliberate
 * exclusions:
 *  - Basic Latin / Western digits, although present in the font — Latin
 *    text must keep the element's own (Latin) font;
 *  - anything the font does not actually cover — the browser then falls
 *    back PER GLYPH to Noto Naskh Arabic (registered after this family in
 *    getFontFamilyFallbacks), which is the safety net for rare/Quranic
 *    letters and non-standard Arabic extensions.
 */
/**
 * User-selectable "Qomra Arabic" family (font picker, persisted id 60):
 * FULL cmap coverage (300 codepoints) — when a user explicitly chooses
 * Qomra, its own Latin letters, digits and punctuation render too, giving a
 * self-consistent typeface. Codepoints the font lacks still fall through
 * per glyph to the family's fallback chain.
 */
export const QomraSelectableFontFaces: ExcalidrawFontFaceDescriptor[] = [
  {
    uri: QomraMedium,
    descriptors: {
      unicodeRange:
        "U+0000, U+000D, U+0020-005D, U+005F, U+0061-007D, U+00A2-00A3, U+00A5, U+00AB, U+00BB, U+00D7, U+00F7, U+060C, U+061B, U+061F, U+0621-063A, U+0640-0655, U+0660-066B, U+066D-0670, U+067E, U+0686, U+06A1, U+06A4, U+06BA, U+06D4, U+2013-2014, U+2018-201A, U+201C-201E, U+2039-203A, U+20AC, U+2212, U+FB57-FB59, U+FB6B-FB6D, U+FB7B-FB7D, U+FB9F, U+FBB2-FBB9, U+FBBD-FBBE, U+FBE8-FBE9, U+FD3E-FD3F, U+FDF2, U+FE82, U+FE84, U+FE86, U+FE88, U+FE8A-FE8C, U+FE8E, U+FE90-FE92, U+FE94, U+FE96-FE98, U+FE9A-FE9C, U+FE9E-FEA0, U+FEA2-FEA4, U+FEA6-FEA8, U+FEAA, U+FEAC, U+FEAE, U+FEB0, U+FEB2-FEB4, U+FEB6-FEB8, U+FEBA-FEBC, U+FEBE-FEC0, U+FEC2-FEC4, U+FEC6-FEC8, U+FECA-FECC, U+FECE-FED0, U+FED2-FED4, U+FED6-FED8, U+FEDA-FEDC, U+FEDE-FEE0, U+FEE2-FEE4, U+FEE6-FEE8, U+FEEA-FEEC, U+FEEE, U+FEF0, U+FEF2-FEFC",
    },
  },
];

export const QomraFontFaces: ExcalidrawFontFaceDescriptor[] = [
  {
    uri: QomraMedium,
    descriptors: {
      unicodeRange:
        "U+060C, U+061B, U+061F, U+0621-063A, U+0640-0655, U+0660-066B, U+066D-0670, U+067E, U+0686, U+06A1, U+06A4, U+06BA, U+06D4, U+FB57-FB59, U+FB6B-FB6D, U+FB7B-FB7D, U+FB9F, U+FBB2-FBB9, U+FBBD-FBBE, U+FBE8-FBE9, U+FD3E-FD3F, U+FDF2, U+FE82, U+FE84, U+FE86, U+FE88, U+FE8A-FE8C, U+FE8E, U+FE90-FE92, U+FE94, U+FE96-FE98, U+FE9A-FE9C, U+FE9E-FEA0, U+FEA2-FEA4, U+FEA6-FEA8, U+FEAA, U+FEAC, U+FEAE, U+FEB0, U+FEB2-FEB4, U+FEB6-FEB8, U+FEBA-FEBC, U+FEBE-FEC0, U+FEC2-FEC4, U+FEC6-FEC8, U+FECA-FECC, U+FECE-FED0, U+FED2-FED4, U+FED6-FED8, U+FEDA-FEDC, U+FEDE-FEE0, U+FEE2-FEE4, U+FEE6-FEE8, U+FEEA-FEEC, U+FEEE, U+FEF0, U+FEF2-FEFC",
    },
  },
];
